/**
 * Reload the page once when a freshly-deployed service worker takes control.
 *
 * `skipWaiting`/`clientsClaim` make the new worker activate immediately, but an
 * already-open tab keeps executing the *old* JS bundle until it reloads — which is
 * why the panel used to look stale until caches were cleared by hand.
 */
export function reloadOnServiceWorkerUpdate() {
  if (!('serviceWorker' in navigator)) return

  // With clientsClaim, a brand-new worker claims an uncontrolled page on the very first
  // visit and fires controllerchange. Reloading then would discard whatever the operator
  // had already typed. Only an *update* — a swap of an existing controller — should reload.
  if (!navigator.serviceWorker.controller) return

  let reloading = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Guard against the reload loop a claiming worker can otherwise cause.
    if (reloading) return
    reloading = true
    window.location.reload()
  })
}
